import { NavigationLink } from './navigation-item.interface';

export type SidenavBadge = NonNullable<NavigationLink['badge']>;

/** Un retard de loyer au-delà de ce délai passe d'orange à rouge. */
const RENT_ARREARS_GRACE_DAYS = 5;

/**
 * Pastille de complétude « Mise en route ». Seuils décidés le 2026-09-22 :
 * moins de 60 % rouge, de 60 à 89 % orange, 90 % et plus vert. Volontairement
 * distincts de `scoreLevel()` (85/70/50), qui sert la page elle-même : l'aside
 * doit pousser vers 90, pas rassurer à 70.
 */
export function setupProgressBadge(percentage: number): SidenavBadge {
  const bgClass =
    percentage < 60 ? 'bg-red-600' : percentage < 90 ? 'bg-orange-500' : 'bg-green-600';
  // Espace fine insécable avant le signe, comme partout ailleurs en français.
  return { value: `${percentage}\u202f%`, bgClass, textClass: 'text-white' };
}

/**
 * Pastille « Loyers impayés » : rien tant que rien n'est en retard ; orange
 * quand tous les retards tiennent dans le délai de grâce ; rouge dès qu'un
 * seul le dépasse. La valeur reste le nombre total d'échéances en retard.
 */
export function rentArrearsBadge(count: number, maxOverdueDays: number): SidenavBadge | undefined {
  if (count <= 0) return undefined;
  return {
    value: String(count),
    bgClass: maxOverdueDays > RENT_ARREARS_GRACE_DAYS ? 'bg-red-600' : 'bg-orange-500',
    textClass: 'text-white'
  };
}

/** Pastille de simple décompte, absente à zéro. */
export function countBadge(count: number, bgClass: string): SidenavBadge | undefined {
  if (count <= 0) return undefined;
  return { value: String(count), bgClass, textClass: 'text-white' };
}
